import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoadingRequest } from '@/hooks/useLoadingRequest';
import { beginTransition } from '@/lib/loading/loadingCoordinatorStore';
import { getHasSettledOnce } from '@/lib/bootGateStore';

/**
 * Route chunk request stub — visual owned by LoadingSurface via coordinator.
 */
export function RouteChunkLoader() {
  const location = useLocation();
  const isWarmNav = getHasSettledOnce();

  /** Always request while Suspense fallback mounted — warm nav uses compact content surface via policy. */
  useLoadingRequest('route-nav', true, {
    routePath: location.pathname,
    idSuffix: 'suspense',
  });

  useEffect(() => {
    if (isWarmNav) {
      beginTransition(location.pathname);
    }
  }, [location.pathname, isWarmNav]);

  return (
    <div
      data-route-chunk-loader={isWarmNav ? 'suppressed' : 'pending'}
      data-loading-transition-suppressed={isWarmNav ? 'true' : undefined}
      className="min-h-[50vh]"
      aria-hidden="true"
    />
  );
}
